import {useSuspenseQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {secretApi} from "../../../api/api";
import {useParams} from "react-router-dom";
import {addSearchListServList} from "../../../store/modules/searchList";
import {useDispatch} from "react-redux";

const useClanDetailApi = () => {
    const params = useParams();
    const clanName = params.clanName
    const dispatch = useDispatch();
    const query = useSuspenseQuery(
        {
            queryKey: ['clanDetailApi',clanName],
            queryFn: async () => {
                const clans = await clanInfoApi({clanName})
                console.log(clans)
                if(clans?.server_id) {
                    dispatch(addSearchListServList(clans))
                }
                return clans
            },
            staleTime: Infinity,
        })


    const data = useMemo(() => {
        if (!query?.data) {
            return {}
        }
        return query.data
    }, [query.data])

    return {query, data};



};
const clanInfoApi = async ({clanName}) => {
    try {
        // const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/sll_first_player`);
        const url = new URL(`${process.env.REACT_APP_CACHE_API}tournament/server_info`);
        url.searchParams.set('server_id',clanName)
        const result = await secretApi.get(url.toString());
        return result.data
    } catch (e) {
        console.log(e)
        return {};
    }
}
export default useClanDetailApi;